<template>
    <div class="pt-4 container-fluid">
        <div class="row">
            <div class="col">
                <ArgonAlert v-if="this.$store.state.user.error" color="danger">
                    Nie udało się załadować profilu użytkownika: {{ this.$store.state.user.error }}
                </ArgonAlert>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonAlert from '../../components/ArgonAlert.vue'
export default {
    components: {
        ArgonAlert
    }
}
</script>